module.exports = __webpack_public_path__ + "img/validating-sobrevivencia.f9f847e0.svg";